import Header from '../../components/Header';
import SidebarProfile from '../../components/SidebarProfile';
import Feed from '../../components/Feed';
import RightSidebar from '../../components/RightSidebar';
import styles from './HomePage.module.css';

export default function HomePage() {
 
  return (
    <div className={styles.container}>
      <Header />
      <main className={styles.main}>
        <div className={styles.sidebar}>
          <SidebarProfile />
        </div>
        <div className={styles.feed}>
          <Feed />
        </div>
        <div className={styles.rightbar}>
          <RightSidebar />
        </div>
      </main>
    </div>
  );
}
